import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const MARGIN_PT = 40;

function fitCanvasToPage(canvas, pdf) {
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const maxW = pageW - 2 * MARGIN_PT;
  const maxH = pageH - 2 * MARGIN_PT;
  const cw = canvas.width;
  const ch = canvas.height;
  let w = maxW;
  let h = (ch * w) / cw;
  if (h > maxH) {
    h = maxH;
    w = (cw * h) / ch;
  }
  const x = (pageW - w) / 2;
  const y = MARGIN_PT + (maxH - h) / 2;
  return { x, y, w, h };
}

function sanitizeFileName(name) {
  const base = (name || 'dashboard').replace(/[/\\?%*:|"<>]/g, '_').trim() || 'dashboard';
  return `${base}.pdf`;
}

/**
 * Browser-only: one PDF page per widget, static raster capture (html2canvas).
 */
export async function exportWidgetsToPdf(elements, options = {}) {
  const { fileNameBase = 'dashboard', onProgress } = options;
  const list = elements.filter(Boolean);
  if (list.length === 0) {
    throw new Error('No widgets to export.');
  }

  const pdf = new jsPDF({ unit: 'pt', format: 'a4', orientation: 'portrait' });

  for (let i = 0; i < list.length; i++) {
    const el = list[i];
    if (onProgress) onProgress(i + 1, list.length);

    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      onclone: (_doc, cloned) => {
        cloned.style.overflow = 'visible';
        cloned.style.height = 'auto';
        cloned.style.maxHeight = 'none';
      },
    });

    const imgData = canvas.toDataURL('image/png');
    if (i > 0) pdf.addPage();
    const { x, y, w, h } = fitCanvasToPage(canvas, pdf);
    pdf.addImage(imgData, 'PNG', x, y, w, h);
  }

  pdf.save(sanitizeFileName(fileNameBase));
}
